module.exports = __webpack_public_path__ + "img/our_banner.1a94774f.png";